if (!customElements.get('card-skick-picker')) {
  customElements.define(
    'card-skick-picker',
    class CardSkickPicker extends HTMLElement {
      connectedCallback() {
        this.formId = this.dataset.formId;
        this.inputs = Array.from(this.querySelectorAll('.card-skick__input'));
        this.card = this.closest('.card-wrapper, .card, li');
        this.onChange = this.onChange.bind(this);
        this.inputs.forEach((input) => input.addEventListener('change', this.onChange));
        const selected = this.inputs.find((input) => input.checked) || this.inputs[0];
        if (selected) this.applySelection(selected);
      }

      disconnectedCallback() {
        this.inputs.forEach((input) => input.removeEventListener('change', this.onChange));
      }

      onChange(event) {
        this.applySelection(event.target);
      }

      applySelection(input) {
        if (!input) return;

        const form = this.formId ? document.getElementById(this.formId) : this.closest('form');
        const variantInput = form?.querySelector('input[name="id"], .product-variant-id');
        if (variantInput) {
          variantInput.value = input.dataset.variantId || input.value;
          variantInput.disabled = input.dataset.available !== 'true';
        }

        const vmbInput = form?.querySelector('[data-vmb-line-property]');
        if (vmbInput) {
          const isVmb = input.dataset.vmb === 'true';
          vmbInput.disabled = !isVmb;
          if (isVmb && vmbInput.dataset.vmbNotice) {
            vmbInput.value = vmbInput.dataset.vmbNotice;
          }
        }

        const submit = form?.querySelector('[type="submit"], .quick-add__submit');
        if (submit) {
          const soldOut = input.dataset.available !== 'true';
          submit.disabled = soldOut;
          const label = submit.querySelector('span:not(.sold-out-message):not(.loading__spinner):not(.icon-wrap)');
          if (label) label.textContent = soldOut ? (submit.dataset.soldOutLabel || 'Slutsåld') : 'Köp';
        }

        if (!this.card || !input.dataset.price) return;
        const priceNodes = this.card.querySelectorAll(
          '.price-item--regular:not(s), .price-item--sale.price-item--last'
        );
        priceNodes.forEach((node) => {
          node.textContent = input.dataset.price;
        });
      }
    }
  );
}
